import { app } from '../../../bootstrap/core';
import { languageSwitcherComponent } from './languageSwitcher.component';

app.component('languageSwitcher', languageSwitcherComponent);
